import { Badge, Button, Tooltip } from 'antd'
import { MessageOutlined } from '@ant-design/icons'
import { observer } from 'mobx-react-lite'
import { useStore } from '../Stores'

const ChatButton = observer(() => {
  const { uiStore, chatStore } = useStore()
  const unread = chatStore.totalUnreadCount

  return (
    <div style={{ position: 'fixed', bottom: 24, right: 24, zIndex: 100 }}>
      <Tooltip title="Відкрити чат" placement="left">
        <Badge count={unread} size="small">
          <Button
            type="primary"
            shape="circle"
            icon={<MessageOutlined />}
            size="large"
            style={{ width: 48, height: 48, fontSize: 20 }}
            onClick={() => uiStore.openDrawer()}
          />
        </Badge>
      </Tooltip>
    </div>
  )
})

export default ChatButton
